import { render, staticRenderFns } from "./empty-services.vue?vue&type=template&id=0fa7d924&"
import script from "./empty-services.vue?vue&type=script&lang=js&"
export * from "./empty-services.vue?vue&type=script&lang=js&"
import style0 from "./empty-services.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports